import React, { memo } from 'react'

import AbstractAgGridCustomHeader from '../AbstractAgGridCustomHeader'
import useStoreSelector from 'utils/hooks/useStoreSelector'

const OutputAgGridCustomHeader = ({
  // AG Grid default props for framework components
  api,
  column,
  setSort,
  displayName,
  enableSorting,
  showColumnMenu,
  // Custom props
  selectionStoreKey,
  selectionSelector,
  outputStore,
  updateSelectionState
}) => {
  const selection = useStoreSelector(selectionStoreKey, selectionSelector)
  const onChangeSelectAllCallback = (newSelectAll) => {
    if (!newSelectAll) {
      api.deselectAll()
    }
    outputStore.update((prevState) =>
      updateSelectionState(
        {
          selectAll: newSelectAll,
          count: newSelectAll ? selection.total : 0
        },
        prevState
      )
    )
  }

  return (
    <AbstractAgGridCustomHeader
      api={api}
      column={column}
      setSort={setSort}
      displayName={displayName}
      enableSorting={enableSorting}
      showColumnMenu={showColumnMenu}
      selection={selection}
      onChangeSelectAllCallback={onChangeSelectAllCallback}
    />
  )
}

export default memo(OutputAgGridCustomHeader)
